import { Outlet } from 'react-router-dom'

export function AuthLayout() {
  return (
    <div className="relative min-h-screen">
      {/* Theme Toggle in top right corner */}
      <div className="absolute top-4 right-4 z-50">
        {/* Theme toggle would go here if needed */}
      </div>

      {/* Single column centered layout matching Next.js */}
      <div className="min-h-screen bg-background flex items-center justify-center p-6">
        <Outlet />
      </div>
    </div>
  )
}